module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "verify-email"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('moreStep')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('verifyEmail'))), _c('span', {
    staticClass: "link"
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(_vm._s(_vm.$t('enjoy'))), _c('span', {
    staticClass: "blod"
  }, [_vm._v(_vm._s(_vm.$t('freeTrial')))])]), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), (!_vm.loading) ? _c('p', [_c('button', {
    on: {
      "click": _vm.sendVerificationCodeToEmail
    }
  }, [_vm._v(_vm._s(_vm.$t('verifyBtn')))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "skip-verify"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v(_vm._s(_vm.$t('skipVerify')))]), _vm._v(_vm._s(_vm.$t('checkAccount')))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66a7ad11!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/verifyEmail/VerifyEmail.vue
// module id = 1340
// module chunks = 1